import { AccountTreeReducerState } from './types';

export const defaultState: AccountTreeReducerState = {
  accountTree: {
    sites: {},
    areas: {},
    roles: {},
  }
};
